export const GIFT_STORE_CLOSED_UNTIL_DATE = "2026-08-25";
const GIFT_STORE_CLOSED_UNTIL_TIMESTAMP = new Date(GIFT_STORE_CLOSED_UNTIL_DATE).getTime();
export const isGiftStoreClosed = () => Date.now() < GIFT_STORE_CLOSED_UNTIL_TIMESTAMP;
//# sourceMappingURL=isGiftStoreClosed.js.map